if (!customElements.get("landing-hero")) {
  class LandingHero extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      if(this.hasAttribute('js-disabled')) return;

      window.addEventListener("scroll", this.handleScroll);
      window.addEventListener("resize", this.handleScroll);

      this.handleScroll();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleScroll);
    }

    handleScroll() {
      const rect = this.firstElementChild.getBoundingClientRect();
      
      const scrollProgress = Math.max(0, Math.min(1, window.scrollY / rect.height));
      
      this.firstElementChild.style.setProperty("--scroll-progress", scrollProgress);
    }
  }

  customElements.define("landing-hero", LandingHero);
}